module.exports = __webpack_public_path__ + "static/media/sj.d27dd8f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sj.svg
// module id = 246
// module chunks = 0